import React from 'react'
import AboutContent from '../components/AboutContent'
import Education from '../components/Education'
import Footer from '../components/Footer'
import HeroImgProject from '../components/HeroImgProject'
import Navbar from '../components/Navbar'
import Skills from '../components/Skills'

const About = () => {
  return (
    <div>
      <Navbar />
      <HeroImgProject heading="About Me" text="I am a FrontEnd Developer"/>
      <AboutContent />
      <Education />
      <Skills /> 
      <Footer />
    </div>
  )
}

export default About